// v2.19 (owner 2026-10-26): the customer's ACC page checks itself about every 30 seconds (paused while the
// tab is hidden) and tells the customer when a revision is ready. The server sends only what the page
// already shows (GET /public/acc/{token}/status). No imports, so Jest can test these helpers.

export const JEDA_MS = 30000;
export const JUDUL_SIAP = "(1) Revisi siap";

// anything the page shows changed: load the page data again (without reloading the page)
export function berubah(lama, baru) {
  if (!lama || !baru) return false;
  const r = (x) => JSON.stringify(x?.revisi || null);
  const t = (x) => x.tahap ?? x.progres?.tahap ?? null;  // v2.20: the progress line moved (page data or /status)
  return ["status", "sudah_diproses", "versi_data", "versi_mockup"].some((k) => lama[k] !== baru[k]) || r(lama) !== r(baru)
    || (t(baru) !== null && t(lama) !== t(baru));
}

// a revision became ready since the last check (a new sent version that answers the customer's request)
export function revisiBaruSiap(lama, baru) {
  if (!baru?.revisi?.siap) return false;
  return !lama?.revisi?.siap || lama.versi_mockup !== baru.versi_mockup;
}

// the status line at the top of the page; `fmt` formats the time
export function statusTeks(d, fmt = (x) => x) {
  const rv = d?.revisi;
  if (!rv || d.sudah_diproses || d.status === "DISETUJUI") return null;
  if (rv.siap) return `Revisi ke-${rv.ke} sudah siap, silakan dicek`;
  return `Desainer sedang mengerjakan revisi ke-${rv.ke}${rv.sejak ? ` (sejak ${fmt(rv.sejak)})` : ""}`;
}

// keep checking while the customer may still answer; v2.20: after the approval too, while the progress line
// can still move (until "Selesai" or a cancelled order)
export const perluPantau = (d) => {
  if (!d) return false;
  if (d.progres) return !d.progres.dibatalkan && d.progres.tahap !== "SELESAI";
  return !d.sudah_diproses && d.status !== "DISETUJUI";
};
